"use strict";

var _interopRequireWildcard = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es6.object.keys");

require("core-js/modules/web.dom.iterable");

require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/core-js/modules/es6.array.iterator.js");

require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/core-js/modules/es6.promise.js");

require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/core-js/modules/es6.object.assign.js");

require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/core-js/modules/es7.promise.finally.js");

var _vue = _interopRequireDefault(require("vue"));

require("normalize.css/normalize.css");

var _elementUi = _interopRequireDefault(require("element-ui"));

require("./styles/element-variables.scss");

require("@/styles/index.scss");

var _App = _interopRequireDefault(require("./App"));

var _store = _interopRequireDefault(require("./store"));

var _router = _interopRequireDefault(require("./router"));

var _lang = _interopRequireDefault(require("./lang"));

require("./icons");

require("./permission");

require("./utils/error-log");

var filters = _interopRequireWildcard(require("./filters"));

require("@fortawesome/fontawesome-free/css/all.css");

// import localStorage from 'js-cookie'
// a modern alternative to CSS resets
// global css
// internationalization
// icon
// permission control
// error log
// global filters
_vue.default.use(_elementUi.default, {
  size: localStorage.getItem('size') || 'medium',
  // set element-ui default size
  i18n: function i18n(key, value) {
    return _lang.default.t(key, value);
  }
}); // register global utility filters


Object.keys(filters).forEach(function (key) {
  _vue.default.filter(key, filters[key]);
});
_vue.default.config.productionTip = false;
_vue.default.config.silent = true; //For Statistic in Message Management

_vue.default.prototype.$pinIcon = '&#128204;';
_vue.default.prototype.$USDIcon = '&#36;';
_vue.default.prototype.$RMBIcon = '&#20803;';
new _vue.default({
  el: '#app',
  router: _router.default,
  store: _store.default,
  i18n: _lang.default,
  render: function render(h) {
    return h(_App.default);
  }
});